import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgbModalModule, NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { NgxKuvUtilsModule } from 'ngx-kuv-utils';
import { NgxKuvToolsModule } from 'ngx-kuv-tools';
import { CompraCreateSharedComponent } from './compra/compra-create-shared/compra-create-shared.component';
import { NgxKuvCreateVentaModule } from 'ngx-kuv-venta';
import { ModalContactoSoporteComponent } from './contacto-soporte/contacto-soporte.component';
import { PageNotFoundComponent } from './page-not-found/page-not-found.component';
import { SugerenciaComponent } from './sugerencia/sugerencia.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FloatingHelpButtonComponent } from './floating-help-button/floating-help-button.component';
import { InfoEmpresaAlertComponent } from './info-empresa-alert/info-empresa-alert.component';
import { NgxMaskModule } from 'ngx-mask';
import { IndexAccionMultipleComponent } from './index-accion-multiple/index-accion-multiple.component';
import { SeleccionarTipoPrecioComponent } from './seleccionar-tipo-precio/seleccionar-tipo-precio.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { VideoPreviewComponent } from './video-preview/video-preview.component';

@NgModule({
  declarations: [
    CompraCreateSharedComponent,
    ModalContactoSoporteComponent,
    PageNotFoundComponent,
    SugerenciaComponent,
    FloatingHelpButtonComponent,
    InfoEmpresaAlertComponent,
    IndexAccionMultipleComponent,
    SeleccionarTipoPrecioComponent,
    VideoPreviewComponent,
  ],
  imports: [
    CommonModule,
    NgbModalModule,
    NgxKuvUtilsModule,
    NgxKuvToolsModule,
    NgxKuvCreateVentaModule,
    NgbTooltipModule,
    FormsModule,
    ReactiveFormsModule,
    NgxMaskModule,
    NgSelectModule,
  ],
  exports:[
    CompraCreateSharedComponent,
    ModalContactoSoporteComponent,
    FloatingHelpButtonComponent,
    InfoEmpresaAlertComponent,
    SeleccionarTipoPrecioComponent,
  ]
})
export class SharedModule { }
